import {inlineError, tracer} from '@s-ui/decorators'
import {UseCase} from '@s-ui/domain'

/**
 * @implements UseCase
 */
export class GetRecommendedAdsUseCase extends UseCase {
  constructor({httpAdsRepository}) {
    super()

    this._httpAdsRepository = httpAdsRepository
  }

  /**
   * @param {String} adId
   */
  @tracer({metric: 'GetRecommendedAdsUseCase#execute'})
  @inlineError
  async execute({adId, maxItems}) {
    const [error, response] = await this._httpAdsRepository.getRecommendedAds({
      adId,
      maxItems
    })

    if (error) return Promise.reject(error)

    return response.toJSON()
  }
}
